/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'

import styled, { layout, color, typography, space } from '@style'

const A = styled.a`
  /* stylelint-disable */
  ${layout}
  ${color}
  ${typography}
  ${space}
`

const OutboundLink = ({ to, children, onClick, ...props }) => {
  return (
    <A href={to} {...props} rel="noopener" onClick={onClick}>
      {children}
    </A>
  )
}

OutboundLink.propTypes = {
  /** Page name to navigate to */
  to: PropTypes.string,
  /** Function to run on click */
  onClick: PropTypes.func,
  /** Target, e.g. _blank */
  target: PropTypes.string,
  /** children */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  /** Relevant for styled-components */
  className: PropTypes.string,
}

OutboundLink.defaultProps = {
  to: '',
  target: '',
  className: null,
  onClick: () => {},
}

export default OutboundLink
